//
//
//
//
//
//
//
//
//
//
//

import PersonalCard from '~/components/Card/PersonalCard';
import BasicInfo from './BasicInfo';
import Steps from './Steps';

export default {
  name: 'CompanyInfo',
  components: {
    PersonalCard,
    BasicInfo,
    Steps,
  },
  data() {
    return {
      activeStep: 0,
      isCertificateSuccess: true,
    };
  },
  methods: {
    setCertificateStatus(certificateStatus) {
      // certificateStatus: 憑證審核狀態(0:待審核 / 1:審核成功 / 2:審核失敗 / 3:未上傳資料)

      this.isCertificateSuccess = certificateStatus !== 2;

      switch (certificateStatus) {
        case 1:
          this.activeStep = 3;
          return;
        case 0:
          this.activeStep = 2;
          return;
        case 2:
        case 3:
        default:
          this.activeStep = 1;
          return;
      }
    },
  },
};
